import { render, staticRenderFns } from "./commentsDialog.vue?vue&type=template&id=9e326e92&scoped=true&"
import script from "./commentsDialog.vue?vue&type=script&lang=js&"
export * from "./commentsDialog.vue?vue&type=script&lang=js&"
import style0 from "./commentsDialog.vue?vue&type=style&index=0&id=9e326e92&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e326e92",
  null
  
)

export default component.exports